import { gql } from '@apollo/client';

export const LISTSEASONS = gql`
  query listSeasons {
    listSeasons(includeDeletedAndPending: false) {
      id
      name
      status
      startDate
      endDate
    }
  }
`;
